/**
 * Single Point of Truth for Asset Taxonomy & Classification across Frontend Views
 * Enforces identical category, management mode, and status evaluation in:
 * - CMDBView
 * - NetworkView
 * - DiscoveryView
 * - ServerDetailModal
 */

export function getAssetCategory(item) {
  if (!item) return "server";

  const category =
    item.asset_category ||
    item.specs?.asset_category ||
    item.type ||
    item.specs?.type;

  if (category) {
    const cLower = String(category).toLowerCase().trim();
    if (cLower.includes("router")) return "router";
    if (cLower.includes("switch")) return "switch";
    if (cLower.includes("firewall")) return "firewall";
    if (cLower.includes("database") || cLower === "db") return "database";
    if (cLower.includes("balancer") || cLower === "lb") return "load_balancer";
    if (cLower.includes("server")) return "server";
    return cLower;
  }

  // Fallback checks on open ports or management type
  const openPorts = item.open_ports || item.openPorts || item.specs?.open_ports || [];
  if (item.management_type === "agentless_snmp" || openPorts.includes(161)) {
    return "router";
  }

  return "server";
}

export function getAssetManagementType(item) {
  if (!item) return "agent";

  const mgt =
    item.management_type ||
    item.specs?.management_type ||
    item.managementType;

  if (mgt) return String(mgt).toLowerCase().trim();

  const openPorts = item.open_ports || item.openPorts || item.specs?.open_ports || [];
  if (openPorts.includes(161)) return "agentless_snmp";

  return "agent";
}

export function getAssetVendorModel(item) {
  if (!item) return { vendor: "Generic Appliance", model: "Generic Device" };

  const vendor =
    item.vendor ||
    item.specs?.vendor ||
    "Generic Appliance";

  const model =
    item.model ||
    item.specs?.model ||
    "Generic Device";

  return { vendor, model };
}

export function formatCategoryLabel(category) {
  const c = String(category || "server").toLowerCase();
  switch (c) {
    case "router":
      return "Network Router";
    case "switch":
      return "Network Switch";
    case "firewall":
      return "Firewall Appliance";
    case "database":
    case "db":
      return "Database Cluster";
    case "load_balancer":
    case "lb":
      return "Load Balancer";
    case "server":
    default:
      return "Server Host";
  }
}

export function formatManagementLabel(item) {
  const mgt = getAssetManagementType(item);
  const cat = getAssetCategory(item);
  const openPorts = item?.open_ports || item?.openPorts || item?.specs?.open_ports || [];

  if (mgt === "agentless_snmp" || cat === "router" || openPorts.includes(161)) {
    return "Agentless";
  }
  return "Agent";
}
